export const commonRoutes = [
  "home",
  "projects",
  "tasks",
  "todos",
  "calendar",
  "kanban",
  "notifications",
  "projects/new",
  "project-templates/new",
  "projects-dashboard",
  "hour-reports",
  "chat",
]

const validRouteSegmentsByContext = {
  user: [
    "home",
    "projects",
    "tasks",
    "todos",
    "calendar",
    "kanban",
    "notifications",
    "projects/new",
    "project-templates/new",
    "settings",
    "hour-reports",
    "chat",
  ],
  org: [
    "projects",
    "tasks",
    "todos",
    "calendar",
    "notifications",
    "projects/new",
    "project-templates/new",
    "settings",
    "members",
    "customers",
    "suppliers",
    "workspaces",
    "projects-dashboard",
    "hour-reports",
    "chat",
  ],
  customer: [
    "home",
    "projects",
    "tasks",
    "todos",
    "calendar",
    "kanban",
    "notifications",
    "projects/new",
    "project-templates/new",
    "settings",
    "projects-dashboard",
    "hour-reports",
    "chat",
  ],
  supplier: [
    "home",
    "projects",
    "tasks",
    "calendar",
    "kanban",
    "notifications",
    "projects/new",
    "project-templates/new",
    "settings",
    "projects-dashboard",
  ],
  workspace: [
    "home",
    "projects",
    "tasks",
    "todos",
    "calendar",
    "kanban",
    "notifications",
    "projects/new",
    "project-templates/new",
    "settings",
    "members",
    "projects-dashboard",
    "hour-reports",
    "chat",
  ],
  member: [
    "home",
    "projects",
    "tasks",
    "todos",
    "calendar",
    "kanban",
    "notifications",
    "projects/new",
    "project-templates/new",
    "settings",
    "projects-dashboard",
    "hour-reports",
    "chat",
  ],
}

export const isCommonRoute = (route: string): boolean => {
  return commonRoutes.includes(route)
}

export const getValidRouteSegmentsByContext = (contextType: ContextType): string[] => {
  if (validRouteSegmentsByContext[contextType]) {
    return [...validRouteSegmentsByContext[contextType]]
  }
  throw new Error(`Invalid context type: ${contextType}`)
}

type ContextType = keyof typeof validRouteSegmentsByContext
